(function($) {
  'use strict';

  function initPageShellV2() {
    var $mainContent = $('.main-content');
    var $legacyContainer = $mainContent.children('.container');
    var hasPageShell = $mainContent.find('.about-page-v2, .contact-page-v2, .faq-page-v2, .default-page-v2, .wishlist-page-v2').length > 0;

    if (!$legacyContainer.length || !hasPageShell) {
      return;
    }

    $mainContent.addClass('main-content--page-shell-v2');
    $legacyContainer.addClass('page-shell-v2__legacy-container');
  }

  if (typeof $ === 'undefined') {
    return;
  }

  $(document).ready(initPageShellV2);
})(window.jQuery);
